import { Trans } from "@lingui/macro";
import { Typography } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { FancyIcon, WfButton, WfIconContentWarningFill } from "@WahooFitness/redesignr";

type MentalRecoveryAcceptanceDrawerProps = {
  onAccept: () => void;
  onCancel: () => void;
  isSavingPreference: boolean;
};

const MentalRecoveryAcceptanceDrawer = ({
  onAccept,
  onCancel,
  isSavingPreference,
}: MentalRecoveryAcceptanceDrawerProps) => {
  const { palette } = useTheme();

  return (
    <Box
      display="flex"
      width="100%"
      py={2}
      gap={2}
      flexDirection="column"
      alignItems="center"
      textAlign="center"
      bgcolor={palette.background.level1}
    >
      <FancyIcon icon={<WfIconContentWarningFill />} color="warning" size="medium" />
      <Typography variant="prose-md-medium" color={palette.text.primary}>
        <Trans>WARNING!</Trans>
      </Typography>
      <Typography
        variant="prose-sm"
        color={palette.text.primary}
        sx={{ textAlign: "left", width: "100%", px: 4 }}
      >
        <Trans>
          Enabling Binaural beats & Subliminal Priming may cause adverse effects for people with
          certain medical conditions. Avoid if you:
        </Trans>
        <ul style={{ paddingLeft: "10px", marginTop: "8px", marginBottom: "8px" }}>
          <li>
            <Trans>• have epilepsy</Trans>
          </li>
          <li>
            <Trans>• have a pacemaker</Trans>
          </li>
          <li>
            <Trans>• are pregnant or may become pregnant</Trans>
          </li>
          <li>
            <Trans>• have a condition that could cause an adverse reaction</Trans>
          </li>
        </ul>
        <Trans>If unsure, please speak with a medical professional before enabling.</Trans>
      </Typography>
      <Box
        display="flex"
        justifyContent="center"
        flexDirection="column"
        alignItems="center"
        width="100%"
        mt={1}
        gap={1}
        py={2}
        px={2}
      >
        <WfButton
          hierarchy="primary"
          intent="default"
          size="large"
          fullWidth
          onClick={onAccept}
          disabled={isSavingPreference}
        >
          <Trans>I accept & enable now</Trans>
        </WfButton>
        <WfButton hierarchy="tertiary" intent="default" size="large" fullWidth onClick={onCancel}>
          <Trans>Cancel</Trans>
        </WfButton>
      </Box>
    </Box>
  );
};

export default MentalRecoveryAcceptanceDrawer;
